<template>
  <div v-if="metadata">
    <div class="vaccine-details">
      <div class="modal-title-head">
        <div class="title-head">
          <p>{{ getPageTitle(type) }}</p>
        </div>
      </div>
      <!-- user name  -->
      <div class="form-group mb-3">
        <p class="column-text">Person Name</p>
        <span class="info">{{ user_name }}</span>
      </div>

      <!-- vaccine  -->
      <div
        v-if="type == 'covid_vaccine' || type == 'covid_recovery'"
        class="vaccine-inputs"
      >
        <!-- vaccine name  -->
        <div class="form-group mb-3" v-if="vaccine_protocol">
          <hr class="vaccine-divider" />
          <p class="column-text">Vaccine Protocol</p>
          <span class="info">{{ vaccine_protocol }}</span>
        </div>

        <!-- vaccine name  -->
        <div class="form-group mb-3" v-if="vaccine_name">
          <hr class="vaccine-divider" />
          <p class="column-text">Vaccine Name</p>
          <span class="info">{{ vaccine_name }}</span>
        </div>

        <!-- batch number  -->
        <div class="form-group mb-3" v-if="batch_number">
          <hr class="vaccine-divider" />
          <p class="column-text">Batch Number</p>
          <span class="info">{{ batch_number }}</span>
        </div>

        <!-- given date  -->
        <div class="form-group mb-3" v-if="given_date">
          <hr class="vaccine-divider" />
          <p class="column-text">Date Given</p>
          <span class="info">{{ given_date }}</span>
        </div>

        <!-- expire date  -->
        <div class="form-group mb-3" v-if="expiry_date">
          <hr class="vaccine-divider" />
          <p class="column-text">Expiry Date</p>
          <span class="info">{{ expiry_date }}</span>
        </div>

        <!-- vaccine file  -->
        <div class="form-group mb-3" v-if="vaccine_pcr_file">
          <hr class="vaccine-divider" />
          <p class="column-text">Vaccine File</p>
          <div
            class="image-details-container"
            v-viewer
            style="position: relative"
          >
            <img class="img-bg-details" :src="vaccine_pcr_file" />
          </div>
        </div>
      </div>

      <!-- pcr  -->
      <div v-else class="pcr-inputs">
        <!-- pcr name  -->
        <div class="form-group mb-3" v-if="pcr_name">
          <hr class="vaccine-divider" />
          <p class="column-text">PCR Result</p>
          <span class="info"> {{ pcr_name }}</span>
        </div>

        <!-- given date  -->
        <div class="form-group mb-3" v-if="pcr_date">
          <hr class="vaccine-divider" />
          <p class="column-text">Date Given</p>
          <span class="info">{{ pcr_date }}</span>
        </div>

        <!-- pcr file  -->
        <div class="form-group mb-3" v-if="vaccine_pcr_file">
          <hr class="vaccine-divider" />
          <p class="column-text">PCR File</p>
          <div
            v-viewer
            class="image-details-container"
            style="position: relative"
          >
            <img class="img-bg-details" :src="vaccine_pcr_file" />
          </div>
        </div>
      </div>

      <div class="form-group mb-3" v-if="notes">
        <hr class="vaccine-divider" />
        <p class="column-text">Document Notes</p>
        <span class="info">{{ notes }}</span>
      </div>
      <hr v-if="getModalInfo.type == 'user_document'" class="action-line" />
    </div>

    <!-- action btns  -->
    <div v-if="getModalInfo.type == 'user_document'" class="d-flex action-btns">
      <button
        v-if="status == 'enabled' && status != 'deleted'"
        class="action-btn btn btn-primary"
        size="md"
        type="button"
        :disabled="getVaccineToggleLoading"
        @click="confirmAction('DISABLED')"
      >
        Disable
        <i
          v-if="getVaccineToggleLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle rounded"
        ></i>
      </button>

      <button
        v-else-if="status == 'disabled' && status != 'deleted'"
        class="action-btn btn btn-primary"
        size="md"
        type="button"
        :disabled="getVaccineToggleLoading"
        @click="confirmAction('ENABLED')"
      >
        Enable
        <i
          v-if="getVaccineToggleLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle rounded"
        ></i>
      </button>

      <button
        class="delete-btn btn mr-2"
        type="button"
        @click="confirmAction('DELETED')"
        :disabled="status == 'deleted' || getVaccineDeleteLoading"
      >
        Delete
        <i
          v-if="getVaccineDeleteLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle rounded"
        ></i>
      </button>
    </div>

    <div v-else class="action-btns okay-btn-details">
      <button
        class="action-btn-details btn btn-primary"
        size="md"
        type="button"
        @click="$bvModal.hide('vaccineDetailsModal')"
      >
        Okay
      </button>
    </div>
  </div>
  <h3 class="mb-0 text-center" v-else>No Data to Display</h3>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { deletedUserMixin } from "@/utils/mixins/deletedUserMixin";
import { startCase } from "lodash";
export default {
  name: "VaccineDetails",
  mixins: [deletedUserMixin],
  data() {
    return {
      user_name: null,
      first_name: null,
      last_name: null,
      type: null,
      // vaccine
      vaccine_protocol: null,
      vaccine_name: null,
      batch_number: null,
      given_date: null,
      expiry_date: null,
      // pcr
      pcr_name: null,
      pcr_date: null,
      notes: null,
      status: false,
      document_Id: null,
      vaccine_pcr_file: null,
      metadata: null,
      protocol: null,
      protocolObj: null,
      protocols: [
        { id: "eu", name: "EU Digital COVID Certificate" },
        { id: "nhs", name: "NHS (Domestic/International)" },
        { id: "shc", name: "Smart Health Card (SHC)" },
        { id: "nys", name: "NYS Excelsior Pass & NYS Excelsior Pass Plus" },
      ],
      isDeletedUser: false,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("users", [
      "getVaccineToggleLoading",
      "getVaccineDeleteLoading",
      "getModalState",
    ]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("vaccineDetailsModal");
    },
  },
  methods: {
    ...mapActions("users", ["userDocumentStatus", "resetLoading"]),
    // handleCovidType() {
    //   switch (this.form.vaccine_pcr) {
    //     case "vaccine":
    //       return "covid_vaccine";
    //     case "pcr":
    //       return "covid_pcr";
    //     default:
    //       break;
    //   }
    // },
    // onSubmit(status) {
    //   const { userDocumentStatus, document_Id } = this;
    //   userDocumentStatus({
    //     id: document_Id,
    //     status,
    //   });
    //   this.$emit('changeUserStatusOrDeleted', this.getModalInfo.data.id);
    // },
    getPageTitle(type) {
      switch (type) {
        case "covid_vaccine":
          return "Vaccine Details";
        case "covid_pcr":
          return "PCR Details";
        case "covid_recovery":
          return "Vaccine Recovery Details";
        default:
          return "Details";
      }
    },
    confirmAction(action) {
      this.$emit("getActionStatusOrDeleted", action);
      this.$bvModal.hide("vaccineDetailsModal");
      this.$bvModal.show("confirmVaccineModal");
    },
  },
  created() {
    if (this.getModalInfo.data.LastVaccine.metadata.protocol) {
      this.protocol = this.getModalInfo.data.LastVaccine.metadata.protocol;
    } else if (this.getModalInfo.data.LastVaccine.protocol) {
      let vaccineFromKiosk = this.getModalInfo.data.LastVaccine.protocol;
      this.protocolObj = this.protocols.filter(function (obj) {
        if (obj.id == vaccineFromKiosk) return obj;
      });
      this.protocol = this.protocolObj[0] ? this.protocolObj[0].name : "";
    }
  },
  beforeMount() {
    this.resetLoading();
  },
  mounted() {
    if (this.getModalInfo) {
      const {
        LastVaccine: {
          type,
          status,
          id,
          expiry_date,
          metadata,
          metadata: { certificateModel, notes, fileAttach },
        },
      } = this.getModalInfo.data;
      const { protocol } = this;

      this.metadata = metadata;
      this.first_name =
        certificateModel &&
        (certificateModel.person.givenName
          ? certificateModel.person.givenName.toLowerCase()
          : certificateModel.person.givenName);
      this.last_name =
        certificateModel &&
        (certificateModel.person.familyName
          ? certificateModel.person.familyName.toLowerCase()
          : certificateModel.person.familyName);
      this.user_name =
        this.first_name && this.last_name
          ? startCase(`${this.first_name} ${this.last_name}`)
          : startCase(this.first_name);
      this.notes = notes && notes != "null" && notes != "" ? notes : null;
      this.type = type;
      this.status = status;
      this.document_Id = id;
      if (type == "covid_pcr") {
        (this.pcr_name = certificateModel.tests
          ? certificateModel.tests[0].testResult == "Detected"
            ? "Positive PCR "
            : "Negative PCR"
          : null),
          (this.pcr_date = certificateModel.tests
            ? moment(certificateModel.tests[0].dateTimeOfTestResult).format(
                "DD/MM/YYYY"
              )
            : null);
      } else {
        this.vaccine_name = certificateModel.vaccinations
          ? certificateModel.vaccinations[0].vaccine
          : null;
        this.expiry_date = expiry_date
          ? moment(expiry_date).format("DD/MM/YYYY")
          : null;
        this.given_date = certificateModel.vaccinations
          ? moment(certificateModel.vaccinations[0].dateOfVaccination).format(
              "DD/MM/YYYY"
            )
          : null;
        this.batch_number = certificateModel.vaccinations
          ? certificateModel.vaccinations[0].batchNumber &&
            certificateModel.vaccinations[0].batchNumber != "null" &&
            certificateModel.vaccinations[0].batchNumber != ""
            ? certificateModel.vaccinations[0].batchNumber
            : null
          : null;

        this.vaccine_protocol = protocol ? protocol : null;
      }
      this.vaccine_pcr_file = fileAttach;

      // console.log('vaccineDetails.document_Id',this.document_Id);
      console.log("this.getModalInfo", this.getModalInfo);
    }
    this.isDeletedUser = this.checkIfUserIsDeleted(
      this.getModalInfo?.data?.Data?.user?.current_entity?.id
    );
  },
};
</script>

<style lang="scss">
div#vaccineDetailsModal {
  div#vaccineDetailsModal___BV_modal_content_ {
    div#vaccineDetailsModal___BV_modal_body_ {
      .vaccine-details {
        .modal-title-head {
          margin-bottom: 42px;

          font-weight: 700;
          font-size: 17px;
          line-height: 20px;

          color: #000000;
        }
        p.column-text {
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 15px;
          color: #c7c7c7;
        }
        span.info {
          font-weight: 400;
          font-size: 16px;
          line-height: 19px;

          color: #495057;
        }
        .image-details-container {
          width: 100px !important;
          height: 38px !important;
          img.img-bg-details {
            width: 100px;
            height: 38px;
          }
        }
      }
      button.action-btn-details.btn.btn-primary {
        width: 111px;
        height: 33px;
        border-radius: 16.6px;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

div#vaccineDetailsModal {
  div#vaccineDetailsModal___BV_modal_content_ {
    width: 491px;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
    border-radius: 26px;
    div#vaccineDetailsModal___BV_modal_body_ {
      padding: 0px !important;

      .vaccine-details {
        padding-inline-start: 46px;
        padding-inline-end: 46px;

        .column-text {
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          /* identical to box height */
          color: #c7c7c7;
        }

        .info {
          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          color: #787878;
        }

        .vaccine-divider {
          opacity: 0.15;
          border: 1px solid #707070;
          margin-top: 19px !important;
          margin-bottom: 19px !important;
        }
      }

      .modal-title-head {
        .title-head {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          margin: 42px auto 42px auto;
          color: #000000;
          p {
            font-weight: 700;
            font-size: 17px;
            line-height: 20px;
          }
        }
      }

      .action-btns {
        margin: 20px auto 20px auto;
        .action-btn {
          background: #103f5e;
          border-radius: 16.6275px;
          width: 111px;
          height: 33px;
          color: #ffffff;

          font-weight: 400;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 19px;
          text-align: center;
          margin-inline-end: 20px !important;
        }

        .delete-btn {
          width: 111px;
          height: 33px;
          border: 1.5px solid #f46a6a;
          border-radius: 16.6275px;
          color: #f46a6a;

          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
      }

      .img-bg {
        // position:absolute;
        z-index: 4;
        width: 100px;
        height: 38px;
        border-radius: 5px !important;
        bottom: 7px;
        inset-inline-start: 143px;
        border: 0px;
      }

      .action-line {
        opacity: 0.15;
        border: 1px solid #707070;
        // width:488px;
        margin-top: 40px !important;
        padding-inline-start: 46px !important;
        padding-inline-end: 46px !important;
      }

      .okay-btn {
        margin-top: 52px;
        margin-bottom: 28px;
      }
    }
  }
}
</style>
